
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.554.562H6.052c-.911 0-1.65.756-1.65 1.688v13.5c0 .932.739 1.687 1.65 1.687h5.502c.912 0 1.651-.755 1.651-1.687V2.25c0-.932-.739-1.688-1.65-1.688z","stroke":"#222F5A","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.052.562h.826c.073 0 .143.03.194.083.052.053.08.124.08.199 0 .149.059.292.162.397a.544.544 0 00.389.165h2.2c.147 0 .287-.06.39-.165a.569.569 0 00.161-.397c0-.075.029-.146.08-.2a.272.272 0 01.195-.082h.825","stroke":"#222F5A","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    